import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import { FilePond } from "react-filepond";
import { requestHeader } from "../../../../axios-project";
import * as Yup from "yup";
import { Button } from "reactstrap";

class documentsForm extends Component {
  render() {
    const { values, handleChange } = this.props;
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("file_name", true);
          this.props.setFieldTouched("file_url", true);
          this.props.setFieldTouched("file_type", true);
          this.props.setFieldTouched("year", true);
          console.log("Cannot submit! Validation failed", errors);
        } else {
          // console.log(values.year);
          values.agency_id = this.props.agencyID;
          func(values);
          this.props.resetForm();
          this.props.close();
        }
      });
    };

    if (values.type === "picture") {
      return (
        <Form key={"picture"}>
          <label>File Description</label>
          <Field
            className="form-control"
            name={"file_description"}
            value={this.props.values.file_description || ""}
          />
          <label className="required">File Source</label>
          <Field
            className="form-control"
            name={"file_source"}
            value={this.props.values.file_source || ""}
          />
          <label className="required" style={this.props.errors.year && this.props.touched.year && {color: "red"}}>Year</label>
          <Field
            className="form-control"
            name={"year"}
            type="number"
            min={1000}
            max={new Date().getFullYear() + 10}
            onChange={handleChange}
          />
          {this.props.errors.year && this.props.touched.year && (
            <small style={{color: "red"}}>{this.props.errors.year}</small>
          )}
          <label className="required" style={this.props.errors.file_name && this.props.touched.file_name && {color: "red"}}>
            <strong>Upload images here</strong>
          </label>
          {this.props.errors.file_name && this.props.touched.file_name && (
            <small style={{color: "red"}}>Upload file before Submit</small>
          )}
          <FilePond
            ref={ref => (this.pond = ref)}
            name={"file"}
            instantUpload={true}
            allowMultiple={true}
            maxFiles={100000}
            allowRevert={false}
            server={{
              url: requestHeader.baseURL,
              load: {
                url: "/downloadFile/",
                headers: requestHeader.headers
              },
              remove: null,
              fetch: null,
              revert: null,
              process: {
                url: "/uploadFile/",
                headers: requestHeader.headers,
                onload: response => {
                  response = JSON.parse(response);
                  this.props.values.file_url = response.fileDownloadUri;
                  this.props.values.file_name = response.fileName;
                  // this.props.values.upload_tstamp = d.toTimeString();
                  this.props.values.file_type = "picture";
                }
              }
            }}
            onupdatefiles={fileItems => {
              this.setState({
                files: fileItems.map(fileItem => fileItem.file)
              });
            }}
          />
          <label className="required">Security Level</label>
          <Field
            className="form-control"
            name={"security_level"}
            component={"select"}
            value={this.props.values["security_level"] || "default"}
            required
          >
            <option value="default" disabled>
              --Select one--
            </option>
            <option value="confidential">Confidential</option>
            <option value="public">Public</option>
          </Field>
          <Button
              color="primary"
            onClick={() => {
              console.log("values", this.props.values);
              validAndHandle(
                this.props.addDocuments,
                this.props.values,
                values.type
              );
            }}
          >
            Submit
          </Button>{" "}
          <Button color="secondary" onClick={this.props.close}>
            Cancel
          </Button>
        </Form>
      );
    } else if (values.type === "video") {
      return (
        <Form key={"video"}>
          <small className={"d-block"}>
            <span style={{ color: "red" }}>*</span> required
          </small>
          <label className="required" style={this.props.errors.file_name && this.props.touched.file_name && {color: "red"}}>File Name</label>
          <Field
            className="form-control"
            name={"file_name"}
            value={this.props.values.file_name || ""}
          />
          {this.props.errors.file_name && this.props.touched.file_name && (
              <div> <small style={{color: "red"}}>{this.props.errors.file_name}</small> </div>
          )}
          <label className="required" style={this.props.errors.file_url && this.props.touched.file_url && {color: "red"}}>Link URL</label>
          <Field
            className="form-control"
            name={"file_url"}
            value={this.props.values.file_url || ""}
          />
          {this.props.errors.file_url && this.props.touched.file_url && (
            <div> <small style={{color: "red"}}>{this.props.errors.file_url}</small> </div>
          )}
          <label>File Description</label>
          <Field
            className="form-control"
            name={"file_description"}
            value={this.props.values.file_description || ""}
          />
          <label className="required">File Source</label>
          <Field
            className="form-control"
            name={"file_source"}
            value={this.props.values.file_source || ""}
          />
          <label className="required" style={this.props.errors.year && this.props.touched.year && {color: "red"}}>Year</label>
          <Field
            className="form-control"
            name={"year"}
            type="number"
            min={1000}
            max={new Date().getFullYear() + 10}
            value={this.props.values.year}
          />
          {this.props.errors.year && this.props.touched.year && (
            <div> <small style={{color: "red"}}>{this.props.errors.year}</small> </div>
          )}
          <label className="required">Security Level</label>
          <Field
            className="form-control"
            name={"security_level"}
            component={"select"}
            value={this.props.values["security_level"] || "default"}
            required
          >
            <option value="default" disabled>
              --Select one--
            </option>
            <option value="confidential">Confidential</option>
            <option value="public">Public</option>
          </Field>

            <br />
          <Button
            color="primary"
            onClick={() => {
              this.props.values.file_type = "video";
              validAndHandle(this.props.addDocuments, this.props.values);
            }}
          >
            Submit
          </Button>{" "}
          <Button color="secondary" onClick={this.props.close}>
            Cancel
          </Button>
        </Form>
      );
    } else {
      return (
        <Form key={"others"}>
          <label className="required" style={this.props.errors.file_name && this.props.touched.file_name && {color: "red"}}>File Name</label>
          <Field
            className="form-control"
            name={"file_name"}
            value={this.props.values.file_name || ""}
          />
          {this.props.errors.file_name && this.props.touched.file_name && (
            <small style={{color: "red"}}>{this.props.errors.file_name}</small>
          )}
          <label className="required" style={this.props.errors.file_url && this.props.touched.file_url && {color: "red"}}>Link URL</label>
          <Field
            className="form-control"
            name={"file_url"}
            value={this.props.values.file_url || ""}
          />
          {this.props.errors.file_url && this.props.touched.file_url && (
            <div> <small style={{color: "red"}}>{this.props.errors.file_url}</small> </div>
          )}
          <label className="required">File type</label>
          <Field
            className="form-control"
            name={"file_type"}
            component={"select"}
            value={this.props.values["file_type"] || "default"}
          >
            <option value="default" disabled>
              --Select one--
            </option>
            <option value="image">Image</option>
            <option value="other">Other</option>
          </Field>
          <label className="required">Security Level</label>
          <Field
            className="form-control"
            name={"security_level"}
            component={"select"}
            value={this.props.values["security_level"] || "default"}
            required
          >
            <option value="default" disabled>
              --Select one--
            </option>
            <option value="confidential">Confidential</option>
            <option value="public">Public</option>
          </Field>
          <label>File Description</label>
          <Field
            className="form-control"
            name={"file_description"}
            value={this.props.values.file_description || ""}
          />
          <label className="required">File Source</label>
          <Field
            className="form-control"
            name={"file_source"}
            value={this.props.values.file_source || ""}
          />
          <label className="required" style={this.props.errors.year && this.props.touched.year && {color: "red"}}>Year</label>
          <Field
            className="form-control"
            name={"year"}
            type="number"
            min={1000}
            max={new Date().getFullYear() + 10}
            value={this.props.values.year}
          />
          {this.props.errors.year && this.props.touched.year && (
              <div> <small style={{color: "red"}}>{this.props.errors.year}</small> <br /> </div>
          )}
          <label className="required">Security Level</label>
          <Field
            className="form-control"
            name={"security_level"}
            component={"select"}
            value={this.props.values["security_level"] || "default"}
            required
          >
            <option value="default" disabled>
              --Select one--
            </option>
            <option value="confidential">Confidential</option>
            <option value="public">Public</option>
          </Field>
          <Button
            className="my-2"
            type="Button"
            color="blue"
            onClick={() => {
              validAndHandle(this.props.addDocuments, this.props.values);
            }}
          >
            Submit
          </Button>{" "}
          <Button type="Button" onClick={this.props.close}>
            Cancel
          </Button>
        </Form>
      );
    }
  }
}

var fileUploadSchema = Yup.object().shape({
  file_name: Yup.string().required(),
  file_url: Yup.string().required(),
  file_type: Yup.string().required(),
  year: Yup.number().required()
});

export default withFormik({
  validationSchema: fileUploadSchema,

  mapPropsToValues({ type }) {
    return {
      type
    };
  }
})(documentsForm);
